<template>
  <section class="mb-panel mb-status">
    <div class="mb-status__cell">
      <span class="mb-status__label">Синхронизация с Moonton</span>
      <span class="mb-status__value">
        <span :class="['mb-dot', 'mb-dot--' + sync.level]"></span>
        {{ sync.text }}
      </span>
    </div>

    <div class="mb-status__cell">
      <span class="mb-status__label">Live-канал (WebSocket)</span>
      <span class="mb-status__value">
        <span :class="['mb-dot', 'mb-dot--' + ws.level]"></span>
        {{ ws.text }}
      </span>
    </div>

    <div class="mb-status__cell">
      <span class="mb-status__label">Последнее обновление</span>
      <span class="mb-status__value">
        {{ timeAgo(lastUpdate, now) }}
        <span v-if="stale" class="mb-badge mb-badge--warning">данные задерживаются</span>
      </span>
    </div>

    <div class="mb-status__cell mb-status__cell--wide">
      <span class="mb-status__label">Ошибка</span>
      <span v-if="errorText" class="mb-error-text">{{ errorText }}</span>
      <span v-else class="mb-muted">нет</span>
    </div>

    <div class="mb-status__action">
      <button type="button"
              :class="['mb-btn', 'mb-btn--sm', needsAttention ? 'mb-btn--warn' : 'mb-btn--ghost']"
              :disabled="busy || !battle"
              @click="$emit('reconnect')">
        <i :class="['fa', 'fa-refresh', {'fa-spin': busy}]"></i>
        Переподключить
      </button>
    </div>
  </section>
</template>

<script>
import {isStale, lastUpdateAt, syncStatus, timeAgo} from '@/common/mlbbBroadcast'

const WS_STATUS = {
  open: {level: 'ok', text: 'Подключено'},
  connecting: {level: 'warn', text: 'Подключаемся…'},
  closed: {level: 'error', text: 'Нет соединения, переподключаемся'},
}

export default {
  name: 'MbMoontonStatus',
  props: {
    battle: {type: Object, default: null},
    wsStatus: {type: String, default: 'closed'},
    // ошибка загрузки по REST (сеть, 404 и т.п.) — отдельно от ошибки Moonton
    loadError: {type: String, default: ''},
    busy: {type: Boolean, default: false},
    now: {type: Number, default: () => Date.now()},
  },
  computed: {
    sync() {
      return syncStatus(this.battle, this.now)
    },
    ws() {
      return WS_STATUS[this.wsStatus] || WS_STATUS.closed
    },
    lastUpdate() {
      return lastUpdateAt(this.battle)
    },
    stale() {
      return isStale(this.battle, this.now)
    },
    errorText() {
      return this.battle?.last_sync_error || this.loadError || ''
    },
    needsAttention() {
      return !!this.errorText || this.battle?.poll_enabled === false || this.wsStatus === 'closed'
    },
  },
  methods: {
    timeAgo,
  },
}
</script>

<style lang="scss">
.mb-status {
  display: grid;
  grid-template-columns: repeat(3, minmax(160px, auto)) minmax(200px, 1fr) auto;
  align-items: center;

  &__cell {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    padding: 12px 18px;
    border-right: 1px solid var(--tl-border);
  }

  &__label { font-size: 11.5px; color: var(--tl-muted); }

  &__value {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    font-size: 13px;
    font-weight: 500;
    color: var(--tl-text);
  }

  &__action { padding: 12px 18px; }

  @media (max-width: 1100px) {
    grid-template-columns: 1fr 1fr;

    &__cell { border-right: 0; border-bottom: 1px solid var(--tl-border); }
  }
}
</style>
